import { Typography } from "@mui/material";
import { ServiceModalOption } from "../ServiceModal.types";
import { ServiceModalOptionsList } from "../ServiceModalOptions.component";
import { EditIcon } from "@icons/EditIcon";
import { DeleteIcon } from "@icons/DeleteIcon";
import { ReportIcon } from "@icons/ReportIcon";
import { SERVICE_MODALS_OPTIONS_STATES } from "../../ServiceFunctionsModal.types";
import { ReplyIcon } from "@icons/ReplyIcon";
import React from "react";
import { ModalReactionsList } from "../../../../Shared/Components/Tippspiel/Reactions/ModalReactionsLists/ModalReactionsList";

export default function StartingOptions({
    selectedComment,
    setOpen,
    onCommentReplyOptionClickHandler,
    setModalCurrentAction,
    handleEditingComment,
    reactOnComment,
    isEditAvailable,
    isOwnComment,
    isEditorial,
}: any) {
    const commentOptions: ServiceModalOption[] = [];

    if (isOwnComment) {
        if (isEditAvailable) {
            commentOptions.push({
                headline: "Beitrag ändern",
                icon: <EditIcon />,
                onOptionClickHandler: () => {
                    setOpen(false);
                    handleEditingComment(selectedComment);
                },
            });
        }
        commentOptions.push({
            headline: "Beitrag löschen",
            icon: <DeleteIcon />,
            onOptionClickHandler: () => {
                setModalCurrentAction(
                    SERVICE_MODALS_OPTIONS_STATES.DELETING_COMMENT,
                );
            },
        });
    } else {
        commentOptions.push({
            headline: "Antworten",
            icon: <ReplyIcon />,
            onOptionClickHandler: () => {
                setOpen(false);
                onCommentReplyOptionClickHandler(selectedComment);
            },
        });
    }
    if (!isOwnComment && !isEditorial) {
        commentOptions.push({
            headline: "Missbrauch melden",
            icon: <ReportIcon />,
            onOptionClickHandler: () => {
                setModalCurrentAction(
                    SERVICE_MODALS_OPTIONS_STATES.REPORTING_CONTENT,
                );
            },
        });
    }

    const modalContent = (
        <>
            {reactOnComment && (
                <ModalReactionsList
                    commentId={selectedComment.commentContent.id}
                    reactOnEntity={reactOnComment}
                    closeModal={() => setOpen(false)}
                />
            )}
            <ServiceModalOptionsList options={commentOptions} />
        </>
    );
    const modalTitle = <Typography>Was möchtest Du tun?</Typography>;
    return { modalTitle, modalContent };
}
